<template>
    <v-container>
        <v-card class="pl-10 pr-10">
        <v-card-title>รายละเอียดใบสั่งซ่อม
            <v-spacer></v-spacer>
            <span class="indigo--text mr-4">สถานะงานซ่อม : <b>{{job.jobStatusName}} </b></span>
            
            <span v-if="isEdited" class="red--text">
                ** มีการแก้ไขข้อมูล**
            </span>
            <!--
            <span v-if="!isEdited && job.receiveParts" class="red--text">
                ** มีรายการรับอะไหล่แล้ว **
            </span>
            -->
            <v-divider
                class="mx-4"
                inset
                vertical
                style="padding-top:10px;"
                ></v-divider>
            <span><v-btn small color="primary" @click="printJob">พิมพ์ใบสั่งซ่อม</v-btn></span>
        </v-card-title>
        <v-divider
                class="mx-4"
                inset
                style="padding-top:10px;"
                ></v-divider>
        <JobHeader ref="jobHeader" @syncJobHeader="syncJobHeader" @loadJob="loadJob" :isEditMode="!canEdit" ></JobHeader>
        
        <v-tabs v-model="currTab" background-color="primary" color="deep-purple accent-4" dark>
                <v-tab key="tab1"> ข้อมูลลูกค้า/รถยนต์ </v-tab>
                <v-tab key="tab2"> ข้อมูลงานซ่อม</v-tab>
                <v-tab key="tab3" v-if="showTab3"> update งานช่าง</v-tab>
                <v-tab key="tab4" v-if="showTabParts"> เบิกอะไหล่</v-tab>
                <v-tab key="tab5" v-if="showTabConsumable"> เบิกวัสดุสิ้นเปลือง</v-tab>
                <v-tab key="tab6" v-if="showTabImage"> แนบภาพงาน</v-tab>
            </v-tabs>
            <v-tabs-items  v-model="currTab">
                <v-tab-item key="tab1">
                    <Tab1 ref="tab1"  :canEdit="!canEdit" :job="job" :branchCode="branchCode"></Tab1>
                </v-tab-item>
                <v-tab-item key="tab2">
                    <Tab2 ref="tab2" :pageCode="pageCode" :key="componentKey" @edited="isEdited = true" :job="job" @onSelectBpe="setBpe"></Tab2>
                </v-tab-item>
                <v-tab-item key="tab3" v-if="showTab3">
                    <Tab3 ref="tab3" :key="componentKey" @edited="isEdited = true" :canFinishJob="job.canFinishJob" :canEdit="canEdit" :isWaiting="job.waitingJobStatus" :jobServiceDetail="job.jobServiceDetail" :branchCode="job.branchCode"  @syncJobServiceDetail="syncJobServiceDetail"></Tab3>
                </v-tab-item>
                <v-tab-item key="tab4" v-if="showTabParts">
                    <Tab4 ref="tab4" :key="componentKey" @edited="isEdited = true" :canEdit="canEdit" :items="job.jobReceiveParts"></Tab4>
                </v-tab-item>
                <v-tab-item key="tab5" v-if="showTabConsumable">
                    <Tab5 ref="tab5" :key="componentKey" @edited="isEdited = true" :canEdit="canEdit" :jobConsumable="job.jobConsumable" :branchCode="job.branchCode" :jobId="jobId" :job="job"></Tab5>
                </v-tab-item>
                <v-tab-item key="tab6" v-if="showTabImage">
                    <Tab6 ref="tab6" :key="componentKey" @edited="isEdited = true" :canEdit="canEdit" 
                        :jobServiceDetails=job.jobServiceDetail
                        :serviceDetails="serviceDetailsForImage"
                        :jobImages=job.jobImages
                        :branchCode="job.branchCode"
                        :jobNo="job.jobNo"></Tab6>
                </v-tab-item>   
            </v-tabs-items>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="canRestate" class="ma-2" color="primary" @click="reState" small >ย้อนสถานะไปรอส่งมอบ</v-btn>
            <v-btn v-if="canEdit" class="ma-2" color="primary" @click="saveJob" small >บันทึก</v-btn>
            <v-btn class="ma-2" color="primary" @click="cancelJob" small > ยกเลิก</v-btn>
        </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import {listServiceDetail} from '@/api/common/dropdown-api.js'
import {getJob, updateJob,printJob, reState} from '@/api/job/job-api.js'
import JobHeader from '../JobHeader'
import Tab1 from './Tab1'
import Tab2 from './Tab2'
import Tab3 from './Tab3'
import Tab4 from './Tab4'
import Tab5 from './Tab5'
import Tab6 from './Tab6'
import dialog from '@/assets/js/dialog.js'
export default {
    name: 'EditJob',
    props: ["jobId", "branchCode", "pageCode"],
    components: {
        JobHeader,
        Tab1,
        Tab2,
        Tab3,
        Tab4,
        Tab5,
        Tab6
    },
    computed: {
        canRestate() {
            return parseInt(this.job.jobStatusCode) == 10 && this.isDelivery;
        },
        serviceDetailsForImage() {
            return this.serviceDetails.filter(o => parseInt(o.value) < 9);
        },
        canEdit() {
           // return true;
            return parseInt(this.job.jobStatusCode) < 10 || !this.isDelivery;
            //return parseInt(this.job.jobStatusCode) < 10;
        },
        showTab3() {
            return this.pageCode == 'J01' || this.pageCode == 'J04';
        },
        showTabParts() {
            return this.pageCode == 'J01' || this.pageCode == 'J04' || this.pageCode == 'J05';
        },
        showTabConsumable() {
            return this.pageCode == 'J01' || this.pageCode == 'J06';
        },
        showTabImage() {
            return this.pageCode == 'J01' || this.pageCode == 'J07';
        }
    },
    data: () => ({
        isDelivery: false,
        componentKey: 0,
        isEdited: false,
        currTab: 0,
        serviceDetails: [],
        job: {
            jobId: -1,
            branchCode: '',
            jobServiceDetail: [],
            jobImages: []
        },
        jobHeader: {
            jobNo: '',
            jobDate: '',
            jobTime: '',
            appointDate: '',
            postponeDate: '',
            jobStatusCode: '',
            jobSize: '',
            empContact: '',
            refJobNo: '',
            invoiceNo: '',
            invoiceDate: '',
            deliveryDate: '',
            finishDate: '',
            carNotPresent: false,
            waitInsurance: false,
            postpone: false,
            remark: ''
        }
    }),
    methods: {
        setBpe(bpe) {
            setTimeout(() => {
                this.job.bpeList = bpe;
            }, 200);
        },
        syncJobHeader(jobHeader) {
            // todo update header
            if (this.job.jobStatusCode == '10') {
                this.job.invoiceDate = jobHeader.invoiceDate;
                this.job.invoiceNo = jobHeader.invoiceNo;
                this.job.deliveryDate = jobHeader.deliveryDate;
                this.job.finishDate = jobHeader.finishDate;
            } 
            this.job.jobDate = jobHeader.jobDate;
            this.job.jobTime = jobHeader.jobTime;
            this.job.appointDate = jobHeader.appointDate;
            this.job.jobSize = jobHeader.jobSize;
            this.job.empContact = jobHeader.empContact;
            this.job.refJobNo = jobHeader.refJobNo;
            this.job.carNotPresent = jobHeader.carNotPresent;
            this.job.waitInsurance = jobHeader.waitInsurance;
            this.job.postpone = jobHeader.postpone;
            this.job.postponeDate = jobHeader.postponeDate;
            
            this.job.remark = jobHeader.remark;
        },
        saveJob() {
            if (this.job.bpeList.length <= 0 || this.job.bpeList.filter(o => !o.deteted).length == 0) {
                dialog.warn("กรุณาเพิ่มข้อมุลใบประเมิน");
                return;
            }
            if (!this.$refs.jobHeader.validate()) {
                return;
            }
            this.$loading(true);
            if (this.$refs.tab6) {
                this.job.jobImages = this.$refs.tab6.getImages();
                if (this.job.jobImages && this.job.jobImages.length > 0) {
                    // when have image it mean jobServiceDetail is have value
                    let _this = this;
                    this.job.jobServiceDetail.forEach(o => {
                        let item = _this.job.jobImages.filter(i => i.jobServiceDetailCode == o.serviceDetailCode);
                        if (item && item.length > 0 &&  item[0].imageDetails) {
                            o.imageCount = item[0].imageDetails.length;
                        }
                        
                    });
                }
            }
            updateJob(this.job).then(() => {
                this.$loading(false);
                //this.$router.go(-1);
                dialog.info("บันทึกข้อมูลสำเร็จ");
                this.loadJob(true);
                this.isEdited = false;
            }).catch(() => {
                this.$loading(false);
            });
            
        },
        cancelJob() {
            this.$router.go(-1);
        },
        syncJobServiceDetail(jobServiceDetail) {
            this.job.jobServiceDetail = jobServiceDetail;
        },
        setJobHeader() {
            this.jobHeader.jobId = this.job.jobId;
            this.jobHeader.jobNo = this.job.jobNo;
            this.jobHeader.jobTime = this.job.jobTime;
            this.jobHeader.jobDate = this.job.jobDate;
            this.jobHeader.appointDate = this.job.appointDate
            this.jobHeader.postponeDate = this.job.postponeDate
            this.jobHeader.jobSize = this.job.jobSize;
            this.jobHeader.empContact = this.job.empContact;
            this.jobHeader.licenseNo = this.job.licenseNo;
            this.jobHeader.refJobNo = this.job.refJobNo;
            this.jobHeader.jobStatusCode = this.job.jobStatusCode;
            this.jobHeader.invoiceNo = this.job.invoiceNo;
            this.jobHeader.invoiceDate = this.job.invoiceDate;
            this.jobHeader.finishDate = this.job.finishDate;
            this.jobHeader.deliveryDate = this.job.deliveryDate;
            this.jobHeader.carNotPresent = this.job.carNotPresent;
            this.jobHeader.postpone = this.job.postpone;
            this.jobHeader.waitInsurance = this.job.waitInsurance;
            this.jobHeader.remark = this.job.remark;
            this.jobHeader.jobStatusCode = this.job.jobStatusCode;
            this.jobHeader.waitInsuranceDate = this.job.waitInsuranceDate;
            this.jobHeader.approveInsuranceDate = this.job.approveInsuranceDate;
        },
        loadJob(isReRender) {
            this.$loading(true);
            getJob(this.jobId).then(rs => {
                this.job = rs;
                this.job.waitingJobStatus = rs.waitingJobStatus;
                this.isDelivery = this.job.deliveryDate;
                this.setJobHeader();
                this.$nextTick(() => {
                    this.$refs.tab1.setTab1Data(this.job.car, this.job.customer, this.job.branchCode);
                    this.$refs.jobHeader.setJobHeader(this.jobHeader);
                    if (isReRender) {
                        this.componentKey += 1;
                    }
                })
                this.$loading(false);
            }).catch(() => {
                this.$loading(false);
            })
        },
        printJob(){
            printJob(this.jobId).then((response) => {
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }));

                const link = document.createElement('a')
                link.href = url;
                link.setAttribute('download', 'ใบสั่งซ่อม_เลขที่_' + this.job.jobNo + '.pdf');
                document.body.appendChild(link);
                link.click();
            });
        },
        reState() {
            reState(this.jobId).then(() => {
                this.$loading(false);
                dialog.info("ย้อนสถานะข้อมูลสำเร็จ");
                this.loadJob(true);
                this.job.deliveryDate = '';
                this.jobHeader.deliveryDate =  '';
                this.isDelivery= false;
                console.log(this.jobHeader.deliveryDate);
                this.$loading(true);
            });
        }
    },
    mounted() {
        if (!this.branchCode || this.branchCode == undefined) {
            this.$router.go(-1);
            return;
        }
        this.loadJob();
        listServiceDetail().then(rs => {
          this.serviceDetails = rs;
          if (this.serviceDetails) {
              this.serviceDetails.forEach((item)  => {
                  item.value = item.value.trim();
              })
          }
      });
    }
}
</script>